<template>
  <v-container class="home">
    <v-icon block size="150" color="success" class="mb-5 mt-5 home__icon">account_circle</v-icon>
    <UserSearch
      :home="true"
      :icon-size="30"
      :subheading="true"
      :font-weight-light="true"
      :white-text="true"
    ></UserSearch>
  </v-container>
</template>

<script>
  import UserSearch from "../components/user/UserSearch";
  export default {
    name: "Home",
    components: {UserSearch}
  }
</script>

<style>
  .home {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 50px;
  }

  .home__icon {
    width: 130px;
    height: 130px;
    background-color: #ffffff;
    border-radius: 50%;
  }
</style>
